<template>
	<div class="omapi-personalization__category">
		<h3 class="omapi-personalization__category-title" :class="'omapi-personalization__category-' + category.slug">
			<component :is="svgName"/>
			<span v-html="category.displayName"></span>
			<span @click="$emit('clearSearch')">
				<common-tooltip
					v-if="search"
					class="omapi-personalization__category-search-icon"
					tooltip="Clear Results"
					:icon="false"
				>
					<svg-close aria-label="Clear Search"/>
				</common-tooltip>
			</span>
		</h3>
		<div class="omapi-personalization__rules">
			<personalization-rule
				v-for="rule in rules"
				:key="rule.id"
				:rule="rule"
			/>
		</div>
	</div>
</template>

<script>

export default  {
	props : {
		category : {
			required : true,
			type     : Object,
		},
		search : {
			default : '',
		},
		rules : {
			required : true,
			type     : Array,
		},
	},
	computed : {
		svgName () {
			return `svg-${this.category.slug}`
		},
	},
}
</script>
